import css from 'styled-jsx/css';
import { MQ_LARGE } from 'constants/mq';

/*
Overview
--------
threeBoxGrid displays from 3 items in one teaser. It is currently only used by recipebox.
*/
export default css`
  .Spread--threeBoxGrid--threeBoxGrid .Spread__item {
    margin-bottom: 1.5rem;
  }

  @supports (display: grid) {
    .Spread--threeBoxGrid .Spread__items {
      grid-gap: 10px;
      grid-template-columns: 1fr 1fr;
      grid-template-areas:
        'one two'
        'one three';
    }

    .Spread--threeBoxGrid .Spread__item--0 {
      grid-area: one;
    }

    .Spread--threeBoxGrid .Spread__item--1 {
      grid-area: two;
    }

    .Spread--threeBoxGrid .Spread__item--2 {
      grid-area: three;
    }

    .Spread--threeBoxGrid.Spread--2 .Spread__items {
      grid-template-areas:
        'one two'
        'one two';
    }

    .Spread--threeBoxGrid {
      grid-template: '1fr';
    }
  }
`;
